import financeiroApi from "@/app/services/financeiro";
import clientesApi from "@/app/services/clientes";
import * as types from "@/app/store/mutation_types";

const TAB_PEDIDOS = 0;
const TAB_PROMISSORIAS = 1;
const TAB_CHEQUES = 2;
const TAB_RECEBIMENTOS = 3;

const TABS = ['pedidos', 'promissorias', 'cheques', 'recebimentos'];

export default {
    namespaced: true,
    state: {
      cliente: {},
      pedidos: [],
      promissorias: [],
      cheques: [],
      recebimentos: [],
      documentos: [],
      valores: [],
      drawer_clientes: false,
      tab: TAB_PROMISSORIAS,

      filtro: {
        cliente_id: null, 
        tipo: 'promissorias', 
        status: 'abertos'
      },

      btnStatus: {
        pedidos: 'abertos',
        promissorias: 'abertos',
        cheques: 'emcaixa'
      }
    },

    getters: {
      somaPromissorias(state) {
        return state.promissorias.reduce((soma, promissoria) => soma + parseFloat(promissoria.valor), 0);
      },
      somaPromissoriasPagas(state) {
        return state.promissorias.reduce((soma, promissoria) => soma + parseFloat(promissoria.valor_pago), 0);
      },
      somaPromissoriasRestante(state) {
        return state.promissorias.reduce((soma, promissoria) => soma + parseFloat(promissoria.valor_restante), 0);
      },
      somaRecebimentos(state) {
        return state.recebimentos.reduce((soma, recebimento) => soma + parseFloat(recebimento.valor), 0);
      },
    },

    mutations: {
      SET_FILTRO (state, filtro) {
        state.filtro = filtro;
      },

      SET_TAB (state, tab) {
        state.tab = tab;
      },

      SET_FINANCEIRO (state, financeiro) {
        state.pedidos      = financeiro.pedidos;
        state.promissorias = financeiro.promissorias;
        state.cheques      = financeiro.cheques;
        state.recebimentos = financeiro.recebimentos;
      },

      SET_PEDIDOS (state, pedidos) {
        state.pedidos = pedidos;
      },

      SET_PROMISSORIAS (state, promissorias) {
        state.promissorias = promissorias;
      },

      SET_CHEQUES (state, cheques) {
        state.cheques = cheques;
      },

      SET_RECEBIMENTOS (state, recebimentos) {
        state.recebimentos = recebimentos;
      },

      SET_DOCUMENTOS (state, documentos) {
        state.documentos = documentos.documentos;
        state.valores    = documentos.valores;
      },

      SET_CONTASARECEBER (state, promissorias) {
        promissorias.forEach(promissoria => {
          if (promissoria.cliente != null)
            promissoria.razao = promissoria.cliente.razao;
            else 
            promissoria.razao = "";
          delete promissoria.cliente;
        })
        state.promissorias = promissorias;
      },

      SET_BTNGROUPS(state, btn_group) {
        state.btnStatus[btn_group.btn] = btn_group.status;
      },
      
      [types.SET_DRAWER_CLIENTES](state, drawer) {
        state.drawer_clientes = drawer;
      },

      [types.SET_CLIENTE_SELECIONADO](state, cliente) {
        state.cliente = cliente;
      },

      [types.EXCLUIR_PROMISSORIA](state, promissoria_id) {
        let index = state.promissorias.findIndex(promissoria => promissoria.id == promissoria_id);
        state.promissorias.splice(index, 1);
      },

      ADICIONAR_PROMISSORIA(state, promissoria) {
        state.promissorias.push(promissoria);
      },

      setarCliente(state, cliente) {
        state.cliente = cliente;
      },

      limparlistas(state) {
        state.pedidos      = [];
        state.promissorias = [];
        state.cheques      = [];
        state.recebimentos = [];
        state.documentos   = [];
        state.valores      = [];
      },

      LIMPAR_PROMISSORIAS (state) {
        state.promissorias = [];
      },
    },

    actions: {
      async contasareceber({commit}, cliente_id) {
        commit('LOADING_ON', null, {root: true});
        let promissorias = await financeiroApi.contasareceber(cliente_id);
        commit('SET_CONTASARECEBER', promissorias);
        commit('LOADING_OFF', null, {root: true});
      },

      async filtrarRecebimentos({commit}, filtro) {
        commit('LOADING_ON', null, {root: true});
        let recebimentos = await financeiroApi.recebimentos(filtro);
        commit('SET_RECEBIMENTOS', recebimentos);
        commit('LOADING_OFF', null, {root: true});
      },

      async extratocliente({commit, state, rootState}) {
        commit('LOADING_ON', null, {root: true});

        let filtro = {
          cliente_id: rootState.clientes.cliente.id,
          tipo: TABS[state.tab],
          status: state.btnStatus[TABS[state.tab]]
        };

        let response = await financeiroApi.extratocliente(filtro);

        if (state.tab == TAB_PEDIDOS) {
          commit('SET_PEDIDOS', response);
        }

        if (state.tab == TAB_PROMISSORIAS) {
          commit('SET_PROMISSORIAS', response);
        }

        if (state.tab == TAB_CHEQUES) {
          commit('SET_CHEQUES', response);
        }

        if (state.tab == TAB_RECEBIMENTOS) {
          commit('SET_RECEBIMENTOS', response);
        }

        commit('LOADING_OFF', null, {root: true});
      },

      async recebimentoDocumentos({commit}, recebimento_id) {
        commit('SET_DOCUMENTOS', []);
        // commit('LOADING_ON', null, {root: true});
        let documentos = await financeiroApi.recebimentoDocumentos(recebimento_id);
        commit('SET_DOCUMENTOS', documentos);
        // commit('LOADING_OFF', null, {root: true});
      },

      async adicionarPromissoria({commit}, promissoria) {
        // commit('LOADING_ON', null, {root: true});
        let retorno_promissoria = await financeiroApi.adicionarPromissoria(promissoria);
        commit('ADICIONAR_PROMISSORIA', retorno_promissoria)
        // commit('LOADING_OFF', null, {root: true});
      },

      async cancelarRecebimento({state, commit, dispatch}, recebimento_id) {
        commit('LOADING_ON', null, {root: true});
        await financeiroApi.cancelarRecebimento(recebimento_id);
        commit('LOADING_OFF', null, {root: true});
      },
      
      async excluirPromissoria({commit}, promissoria_id) {
        // commit('LOADING_ON', null, {root: true});
        await financeiroApi.excluirPromissoria(promissoria_id);
        commit('EXCLUIR_PROMISSORIA', promissoria_id)
        // commit('LOADING_OFF', null, {root: true});
      },

      async setarCliente({commit}, cliente_id) {
        let cliente = null;
        if (cliente_id) {
          cliente = await clientesApi.abrir(cliente_id);
        }
        commit('setarCliente', cliente);
      },

      
      async cancelarPagamento({state, commit, dispatch}, pagamento_id) {
        commit('LOADING_ON', null, {root: true});
        await financeiroApi.cancelarPagamento(pagamento_id);
        commit('LOADING_OFF', null, {root: true});
      },
      
    }
}
